function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("radialGradient", {
  id: "a",
  cx: "51.233%",
  cy: "50%",
  r: "120.292%",
  fx: "51.233%",
  fy: "50%",
  gradientTransform: "matrix(.4054 0 0 .30015 .305 .35)"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#464545"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFF",
  stopOpacity: 0
})));

var SvgMapMarkerShadow = function SvgMapMarkerShadow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 36,
    height: 11,
    viewBox: "0 0 36 11",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, React.createElement("ellipse", {
    style: {
      mixBlendMode: "multiply"
    },
    cx: 273.5,
    cy: 454.5,
    fill: "url(#a)",
    fillOpacity: 0.65,
    fillRule: "evenodd",
    rx: 18.5,
    ry: 7.5,
    transform: "translate(-256 -449)"
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMapMarkerShadow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/map-marker-shadow.9f2c7b81.svg";
export { ForwardRef as ReactComponent };